module.exports = __webpack_public_path__ + "static/persona3-53ffdbba9befdefb1a0f497f58bbd282.png";